import Meta from '@/components/common/Meta'

import StorageAndShippingServicesPage from '@/v2/components/pages/landing-pages/storage-and-shipping-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-and-shipping-services-page'

interface StorageAndShippingServicesPageProps {}

const Page: React.FC<StorageAndShippingServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageAndShippingServicesPage />
    </>
  )
}

export default Page
